import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

import { computed, ref, toRef, useAttrs } from 'vue'
import QSelect from 'quasar/src/components/select/QSelect.js';
import useSelectable from '../composables/useSelectable'


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: [Object, String, Number, Boolean, Array],
    default: undefined,
  },
  options: {
    type: Array,
    default: () => [],
  },
  multiple: Boolean,
  dense: Boolean,
  useInput: Boolean,
  emitValue: Boolean,
  optionLabel: {
    type: String,
    default: 'label',
  },
  optionValue: {
    type: String,
    default: 'value',
  },
  placeholder: {
    type: String,
    default: undefined,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { expose, emit }) {

const props = __props


const attrs = useAttrs()

expose({
  clearInputValue,
})



// State etc.
const internalOptions = ref(props.options)
const selectRef = ref<QSelect>()
const { allSelectedStatus, toggleAllItemsWithEmit } = useSelectable(toRef(props, 'options'), toRef(props, 'modelValue'))

const selectedPlaceholder = computed(() => {
  if (props.dense) {
    const placeholder = props.placeholder || ''

    if (!props.multiple) {
      return props.modelValue ? getOptionLabel(props.modelValue) : placeholder
    } else {
      return Array.isArray(props.modelValue) && props.modelValue?.length ? `${placeholder} (${props.modelValue.length})` : placeholder
    }
  }

  return props.placeholder
})

function getOptionLabel (opt) {
  return opt[props.optionLabel] || opt
}

function filter (val, update) {
  update(
    () => {
      const lowerCaseValue = val?.toLowerCase()
      internalOptions.value = props.options.filter(option => getOptionLabel(option).toLowerCase().indexOf(lowerCaseValue) > -1)
    },

    // "ref" is the Vue reference to the QSelect
    ref => {
      if (val !== '' && ref.options.length > 0) {
        // Reset optionIndex in case there is something selected
        ref.setOptionIndex(-1)

        // If it is possible to add new values then only try to focus on an exact match.
        // If we can't add new values then always focus on the first item.
        if (attrs.onNewValue) {
          // Try to find a matched item.
          const lowerCaseValue = val?.toLowerCase()
          const optionsIndex = ref.options.findIndex(option => getOptionLabel(option).toLowerCase() === lowerCaseValue)

          // If there is no exact match (casing excluded) then don't set focus.
          // This is to allow adding new items, or it'll just toggle the focused item which can make it impossible to add new values.
          if (optionsIndex > -1) {
            // The q-select options starts at index 1.
            ref.moveOptionSelection(optionsIndex + 1, true)
          }
        } else {
          // The q-select options starts at index 1.
          ref.moveOptionSelection(1, true)
        }
      }
    },
  )
}

function clearInputValue () {
  if (selectRef.value) {
    selectRef.value.updateInputValue('', true)
  }
}

function onModelUpdate (val) {
  emit('update:modelValue', val)
}

function onToggleAll (evt, emitString) {
  if (selectRef.value) {
    selectRef.value.hidePopup()
  }

  toggleAllItemsWithEmit(evt, emitString)
}

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!

  return (_openBlock(), _createBlock(_unref(QSelect), _mergeProps({
    ref_key: "selectRef",
    ref: selectRef,
    class: "c-select",
    "model-value": __props.modelValue
  }, __props.dense ? _ctx.$inri.inputDense : _ctx.$inri.input, {
    options: internalOptions.value,
    multiple: __props.multiple,
    "use-input": __props.dense || __props.useInput,
    placeholder: _unref(selectedPlaceholder),
    "hide-selected": __props.dense,
    "emit-value": __props.emitValue,
    "option-label": __props.optionLabel,
    "option-value": __props.optionValue,
    "clear-icon": "mdi-close",
    onBlur: clearInputValue,
    onFilter: filter,
    "onUpdate:modelValue": onModelUpdate
  }), _createSlots({
    "no-option": _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('inri.select.no_results')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    option: _withCtx(({ itemProps, opt, selected, toggleOption }) => [
      (__props.multiple)
        ? (_openBlock(), _createBlock(_component_q_item, _normalizeProps(_mergeProps({ key: 0 }, itemProps)), {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_checkbox, _mergeProps({ "model-value": selected }, _ctx.$inri.checkbox, {
                    label: getOptionLabel(opt),
                    tabindex: "-1",
                    onClick: ($event: any) => (toggleOption(opt))
                  }), null, 16, ["model-value", "label", "onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1040))
        : (_openBlock(), _createBlock(_component_q_item, _normalizeProps(_mergeProps({ key: 1 }, itemProps)), {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getOptionLabel(opt)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1040))
    ]),
    _: 2
  }, [
    (__props.multiple)
      ? {
          name: "before-options",
          fn: _withCtx(() => [
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_checkbox, _mergeProps({ "model-value": _unref(allSelectedStatus) }, _ctx.$inri.checkbox, {
                      label: _ctx.$t('inri.select.select_all'),
                      tabindex: "-1",
                      onClick: onToggleAll
                    }), null, 16, ["model-value", "label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        }
      : undefined
  ]), 1040, ["model-value", "options", "multiple", "use-input", "placeholder", "hide-selected", "emit-value", "option-label", "option-value"]))
}
}

})